
// These sizes are mapped to the srcset images in the listing view, we have the ability to have multipel sets, one for legacy and one for modern
const listingSrcSetSizes = {
    '> 1800': {
        legacy: 520,
        modern: 800
    },

    '> 1440 && < 1799': {
        legacy: 500,
        modern: 670
    },

    '> 1200 && < 1439': {
        legacy: 380,
        modern: 550
    },

    '> 992 && < 1199': {
        legacy: 500,
        modern: 450,
    },

    '> 768px && < 991': {
        legacy: 475,
        modern: 440
    },

    '> 540 && < 767 x1': {
        legacy: 360,
        modern: 360,
    },

    '> 540 && < 767 x2': {
        legacy: 720,
        modern: 720,
    },

    '< 539 x1': {
        legacy: 530,
        modern: 530,
    },

    '< 539 x2': {
        legacy: 1060,
        modern: 1060,
    }
};

const listingAspectRatios = {
    'landscape': {
        legacy: 55.7,   
        modern: {
            mobile: 68.5,
            desktop: 68.5,
        }
    },

    'portrait': {
        legacy: 116.2,
        modern: {
            mobile: 140.1,
            desktop: 116.2,
        }
    },
}

// Look up the srcset sizes for provided viewport rule to run through dictionary set
const getImageSrcSetSizeBasedOnGallery = (viewportRule, galleryVersion) => {
    try {
        if (listingSrcSetSizes[viewportRule] === null) return 'unknown';
        else return (galleryVersion === 'legacy' ? listingSrcSetSizes[viewportRule].legacy : listingSrcSetSizes[viewportRule].modern);
    } catch (e) {
        console.error(viewportRule);
    }
};

// Look up the aspect ratios based on ratio and gallery

const getImageAspectRatioBasedOnGallery = (aspectRule, galleryVersion) => {
    try {
        if (listingAspectRatios[aspectRule] === null) return 'unknown';
        else return (galleryVersion === 'legacy' ? listingAspectRatios[aspectRule].legacy : getImageAspectRatioResponsive(listingAspectRatios[aspectRule].modern));
    } catch (e) {
        console.error(aspectRule);
    }
};

const getImageAspectRatioResponsive = (ratioSizes) => {
    const viewportWidth = window.innerWidth;

    try {
        if (viewportWidth < 768) return ratioSizes.mobile;
        if (viewportWidth >= 768) return ratioSizes.desktop;
    } catch (e) {
        console.error(aspectRule);
        return 'unknown';
    }
}

// We need to determine where the modal will "start" so it can animate in correctly, this position will also be used when closing
const calculateEnterExitModalPosition = () => {
    const buffer = 10;
    if (checkVersion() == null && window.innerWidth >= 768) {
        return Math.round(window['scrolInstance'].scroll.instance.scroll.y + window.innerHeight + buffer);
    }
    else {
        return Math.round(window.scrollY + window.innerHeight + buffer);
    }
} 

const checkVersion = () => {
    const agent = window.navigator.userAgent;
    const start = agent.indexOf('OS ');
    if (agent.indexOf('iPhone') > -1 && start > -1) {
        return {
            device: 'iPhone',
            version: parseFloat(agent.substr(start + 3, 4).replace('_', '.'))
        }
    } else {
        // No version found yet, check specifically for iPad
        const detectediPadVersion = detectiPadOSVersion();
        if (detectediPadVersion !== false) {
            return {
                device: 'iPad',
                version: detectediPadVersion
            }
        }
    }

    return null;
}

const detectiPadOSVersion = () => {
    if (navigator.platform !== 'MacIntel' || navigator.maxTouchPoints <= 1) return false;
    
    const version = navigator.userAgent.match(/Version\/(\d+)\.(\d+)\.?(\d+)?/);
    const major = version && version[1] ? version[1] : null;
    const minor = version && version[2] ? version[2] : null;
    const patch = version && version[3] ? version[3] : null;

    if (major && minor) {
        return parseFloat(`${major}.${minor}`);
    } else {
        return false;
    }
}

// Page Scrolling

const preventPageScrolling = () => {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

const allowPageScrolling = () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.removeEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

const preventDefault = (e) => {
    e.preventDefault();
}

const preventDefaultForScrollKeys = (e) => {
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
    
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
    }));
} catch (e) { }

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';






const divMod = (n, m) => [Math.floor(n / m), n % m];

// This function takes a value in miliseconsd and converts it to the corresponding correct human
// format in days, hours, minutes and seconds. We always return "minutes" and "seconds" but others are optinoal
const durationTextFormatter = (locale, unitDisplay = 'long') => {
    try {
        const timeUnitFormatter = (locale, unit, unitDisplay) =>  Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay }).format;

        const fmtDays = timeUnitFormatter(locale, 'day', unitDisplay),
            fmtHours = timeUnitFormatter(locale, 'hour', unitDisplay),
            fmtMinutes = timeUnitFormatter(locale, 'minute', unitDisplay),
            fmtSeconds = timeUnitFormatter(locale, 'second', unitDisplay),
            fmtMilliseconds = timeUnitFormatter(locale, 'millisecond', unitDisplay),
            fmtList = new Intl.ListFormat(locale, { style: 'long', type: 'unit' }); // use conjuction for "x and y"

        return (milliseconds) => {
            let days, hours, minutes, seconds;
            [days, milliseconds] = divMod(milliseconds, 86400000);
            [hours, milliseconds] = divMod(milliseconds, 3600000);
            [minutes, milliseconds] = divMod(milliseconds, 60000);
            [seconds, milliseconds] = divMod(milliseconds, 1000);


            return [
                days ? fmtDays(days) : null,
                hours ? fmtHours(hours) : null,
                minutes = fmtMinutes(minutes), // This zero is so we can have a value showing of 0
                seconds = fmtSeconds(seconds),
                milliseconds ? fmtMilliseconds(milliseconds) : null
            ].join(' ').trim();

            // return fmtList.format([
            //     days ? fmtDays(days) : null,
            //     hours ? fmtHours(hours) : null,
            //     minutes = fmtMinutes(minutes), // This zero is so we can have a value showing of 0
            //     seconds = fmtSeconds(seconds),
            //     milliseconds ? fmtMilliseconds(milliseconds) : null
            // ].filter(v => v !== null));
        }
    } catch (e) {
        if (e instanceof RangeError) {
            return '';
        }
    }
};



export {
    listingSrcSetSizes,
    getImageSrcSetSizeBasedOnGallery,
    calculateEnterExitModalPosition,
    checkVersion,
    preventPageScrolling,
    allowPageScrolling,
    getImageAspectRatioBasedOnGallery,
    durationTextFormatter
}